






















import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import Vue from "vue";
export default Vue.extend({
  props: ["modalData"],
  components: {
    Modal,
  },
  setup() {
    const modal_config: ModalConfig = {
      desc: "",
      title: "",
      width: "45rem",
      height: "auto",
      blank: true,
      withTopRightCloseBtn: true,
    };
    return {
      modal_config,
    };
  },
});
